<template>
    <div
        class="contact_name flex items-center last-of-type:mb-0"
        :class="[notMb ? '' : 'mb-[0.6875rem]', isFull ? 'w-full' : '', isLarge ? '!block' : '']"
    >
        <div
            v-if="badgeClass && nameLetter"
            class="name_icon__letter_text uppercase w-8 h-8"
            :class="[
                badgeClass,
                isTab ? '!w-6 !h-6 !text-xs !rounded-full !min-w-[auto]' : '',
                isSmall ? '!w-4 !h-4 !text-[0.625rem] min-w-[16px]' : 'h-8 w-8 min-w-[32px]',
                isLarge ? '!h-20 !w-20 block !text-8 font-normal !leading-[45px] mb-2' : '',
                isDetail
                    ? '!h-[5.5625rem] !w-[5.5625rem] !mr-0 !border-2 !border-white !text-[2rem] leading-normal !mb-3'
                    : '',
            ]"
        >
            {{ nameLetter }}{{ lastNameLetter }}

            <span class="online_indicator" v-if="isOnline"></span>
            <span
                class="absolute bottom-0 -right-1 w-3 h-3 flex items-center justify-center bg-green-500 rounded-full"
                v-if="isApproved"
            >
                <fa class="text-xs text-white" :icon="['fas', 'check']"></fa>
            </span>

            <span
                v-if="isCancelAble"
                @click="() => emits('handleClick', 'cancel')"
                class="absolute top-0 -right-1 w-4 h-4 flex items-center justify-center bg-gray-300 rounded-full cursor-pointer"
            >
                <fa class="text-xs text-white" :icon="['fas', 'xmark']"></fa>
            </span>
        </div>
        <div v-else>
            <img
                v-if="userInfo && userInfo?.image_path"
                :src="userInfo.image_path"
                alt="user image"
                class="w-6 h-6 rounded-full mr-2.5"
            />
        </div>

        <div
            class="name_icon__text"
            :class="[
                isLarge ? '!max-w-[100%]' : '',
                isDetail ? '!text-lg !font-semibold !leading-[22px] mb-[2px]' : '',
                isSmall ? '!text-[12px] !font-normal' : '',
            ]"
        >
            <p v-if="nameText" class="flex flex-col" :class="[nameTextClass, tenanatLabel ? '!text-[12px]' : '']">
                <span class="truncate" v-html="highlightText(nameText, searchQuery)"> </span>
                <span v-if="tenanatLabel" class="text-[10px] leading-[12.1px] font-bold text-black-900">
                    {{ tenanatLabel }}
                </span>
            </p>

            <div :class="[detailClass]">
                <span class="" v-if="email">
                    {{ email }}
                </span>

                <span v-if="phone && phone !== 'null'"> - {{ phone }} </span>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref } from "vue";
const userInfo = ref([]);
userInfo.value = {
    id: 1,
    first_name: "imran",
    title: "Mr",
    image: "http://192.168.1.212:9002/voza-local/static-content/default-user.png",
    image_path: "http://192.168.1.212:9002/voza-local/static-content/default-user.png",
};

// [todo]: rather than isMedium, isLarge, isSmall we should just add a size prop
// [todo]: rather than isApproved, isCancelAble, isDetail, isTab we should just add a single state prop

const emits = defineEmits(["handleClick"]);

const props = defineProps({
    nameArray: {
        type: Array,
        default: () => [],
    },
    nameText: {
        type: String,
        default: "",
    },
    nameTextClass: {
        type: String,
        default: "",
    },
    detailClass: {
        type: String,
        default: "",
    },
    nameLetter: {
        type: String,
        default: "",
    },
    notMb: {
        type: Boolean,
        default: false,
    },
    lastNameLetter: {
        type: String,
        default: "",
    },
    isMedium: {
        type: Boolean,
        default: false,
    },
    isLarge: {
        type: Boolean,
        default: false,
    },
    color: {
        type: String,
        default: "",
    },
    badgeClass: {
        type: String,
        default: "",
    },
    isOnline: {
        type: Boolean,
        default: false,
    },
    isApproved: {
        type: Boolean,
        default: false,
    },
    isCancelAble: {
        type: Boolean,
        default: false,
    },
    isFull: {
        type: Boolean,
        default: true,
    },
    email: {
        type: String,
        default: "",
    },
    phone: {
        type: String,
        default: "",
    },
    isSmall: {
        type: Boolean,
        default: false,
    },
    isDetail: {
        type: Boolean,
        default: false,
    },
    isTab: {
        type: Boolean,
        default: false,
    },
    tenanatLabel: {
        type: String,
        default: "",
    },
    searchQuery: {
        type: String,
        default: "",
    },
});

function highlightText(text, query) {
    if (!query || !text) return text; // Return original text if no query or text

    const regex = new RegExp(`(${query})`, "gi"); // Case-insensitive match
    return text.replace(regex, '<span class="highlight">$1</span>'); // Wrap match in a span
}
</script>
<style scoped>
.name_icon__letter_text {
    @apply inline-flex items-center justify-center rounded-full mr-1 text-white relative text-lg;
}

.name_icon__text {
    @apply text-sm font-normal text-black-600 flex flex-col max-w-[85%] whitespace-nowrap overflow-hidden text-ellipsis dark:text-dm-white;
}

.online_indicator {
    @apply w-[9px] h-[9px] border-2 rounded-full bg-green-500 border-white absolute -top-[2px] -right-[1.5px];
}

.nameIcon-ellipsis .name_icon__text span {
    @apply max-w-[65px] w-full text-ellipsis overflow-hidden;
}

.nameIcon-ellipsis .name_icon__text {
    @apply !text-[16px] !font-bold;
}

/* .nameIcon-ellipsis  */
</style>

<style>
.highlight {
    background-color: #87ffe3;
}
</style>
